// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h_la","label":"styles_label__2Q9sX"};